import { render } from "./Hero.vue?vue&type=template&id=251c3a1c"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=251c3a1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__